module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("triv·i·a")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("noun")]), _c('br'), _vm._v("\r\ndetails, considerations, or pieces of information of little importance or value.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("I love trivia and I thought that you might too.")]), _vm._v(" "), _c('h3', [_vm._v("Made by "), _c('a', {
    staticClass: "link-dark",
    attrs: {
      "href": "http://christopherianmurphy.com"
    }
  }, [_vm._v("Christopher Murphy")])]), _vm._v(" "), _c('p', [_vm._v("Powered by the "), _c('a', {
    staticClass: "link-light",
    attrs: {
      "href": "https://opentdb.com/"
    }
  }, [_vm._v("Open Trivia Database")]), _vm._v(".")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dd4c242"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 47
// module chunks = 0